import React from "react"
import { Typography, Grid, Divider } from "@mui/material"

const calculate = (bought, sold) => {
  // const totalOriginalPriceBought = bought.reduce((partialSum, element) => partialSum + element.book.priceOriginal, 0)
  const totalNegotiatedPriceBought = bought.reduce((partialSum, element) => partialSum + element.priceNegotiated, 0)

  const totalNegotiatedPriceSold = sold.reduce((partialSum, element) => partialSum + element.priceNegotiated, 0)
  // const totalOriginalPriceSold = sold.reduce((partialSum, element) => partialSum + element.book.priceOriginal, 0)

  return {
    bought: {
      amount: bought.length,
      total: totalNegotiatedPriceBought,
    },
    sold: {
      amount: sold.length,
      total: totalNegotiatedPriceSold,
    },
  }
}

const HistoryCalculation = ({ boughtBooks, soldBooks, isMobile }) => {
  const statistics = calculate(boughtBooks, soldBooks)
  const { bought, sold } = statistics

  return (
    <Grid container>
      {/* {isMobile ? (
        <Grid item xs={12}>
          <Typography variant="caption">
            Ergebnisse können abweichen, wenn von der Schule kein Originalpreis angegeben wurde. Bücherpakete werden nicht berücksichtigt.
          </Typography>
        </Grid>
      ) : (
        <></>
      )} */}
      <Grid item container xs={isMobile ? 12 : 5.9} sx={{ mt: isMobile ? 0 : 0 }}>
        <Grid item xs={isMobile ? 10 : 6}>
          <Typography ml={1}>Gekaufte Bücher</Typography>
        </Grid>
        <Grid item xs={isMobile ? 2 : 6}>
          <Typography align="right">{bought.amount}</Typography>
        </Grid>

        <Grid item xs={isMobile ? 10 : 6}>
          <Typography ml={1}>Gekauft für insgesamt</Typography>
        </Grid>
        <Grid item xs={isMobile ? 2 : 6}>
          <Typography align="right">{bought.total} €</Typography>
        </Grid>

        {/* {kaufen.originalSumme ? (
          <>
            <Grid item xs={isMobile ? 10 : 6}>
              <Typography ml={1}>Originalsumme</Typography>
            </Grid>
            <Grid item xs={isMobile ? 2 : 6}>
              <Typography align="right">{kaufen.originalSumme} €</Typography>
            </Grid>
            {kaufen.gespart ? (
              <>
                <Grid item xs={isMobile ? 10 : 6}>
                  <Typography ml={1}>Gespart durch Bookay</Typography>
                </Grid>
                <Grid item xs={isMobile ? 2 : 6}>
                  <Typography align="right">{kaufen.gespart} €</Typography>
                </Grid>
              </>
            ) : null}
          </>
        ) : null} */}
      </Grid>
      <Grid item xs={isMobile ? 12 : 0.2}>
        <Divider sx={{ my: isMobile ? 2 : 0 }} orientation={isMobile ? "horizontal" : "vertical"} />
      </Grid>
      <Grid item container xs={isMobile ? 12 : 5.9}>
        <Grid item xs={isMobile ? 10 : 6}>
          <Typography ml={1}>Verkaufte Bücher</Typography>
        </Grid>
        <Grid item xs={isMobile ? 2 : 6}>
          <Typography align="right">{sold.amount}</Typography>
        </Grid>

        <Grid item xs={isMobile ? 10 : 6}>
          <Typography ml={1}>Verkauft für insgesamt</Typography>
        </Grid>
        <Grid item xs={isMobile ? 2 : 6}>
          <Typography align="right">{sold.total} €</Typography>
        </Grid>

        {/* {sold.originalSumme ? (
          <>
            <Grid item xs={isMobile ? 10 : 6}>
              <Typography ml={1}>Originalsumme</Typography>
            </Grid>
            <Grid item xs={isMobile ? 2 : 6}>
              <Typography align="right">{verkaufen.originalSumme} €</Typography>
            </Grid>
          </>
        ) : null} */}
        {/* {verkaufen.wiedergewonnen && verkaufen.wiedergewonnen > 0 ? (
          <>
            <Grid item xs={isMobile ? 10 : 6}>
              <Typography ml={1}>Wiedergewonnen durch Bookay</Typography>
            </Grid>
            <Grid item xs={isMobile ? 2 : 6}>
              <Typography align="right">{verkaufen.wiedergewonnen} €</Typography>
            </Grid>
          </>
        ) : null} */}
      </Grid>
    </Grid>
  )
}

export default HistoryCalculation
